/**
 * Anam Client Tools
 *
 * Built-in client tool definitions and handler registration for Anam avatars.
 * Client tools allow the Anam persona to trigger UI actions during conversation.
 */

import type AnamClient from '@anam-ai/js-sdk/dist/module/AnamClient'
import type { AvatarSessionEvents } from './IAvatarProvider'

/**
 * Built-in client tool definitions.
 * These are included in the session token request when client tools are enabled.
 */
export const BUILT_IN_CLIENT_TOOLS = [
  {
    type: 'client' as const,
    name: 'show_sources',
    description:
      'Show the source documents panel when the user asks to see references, citations, or sources',
    parameters: {
      type: 'object',
      properties: {},
    },
  },
]

/**
 * Register built-in tool call handlers with the Anam client.
 * Returns a cleanup function that unregisters all handlers.
 */
export function registerBuiltInToolHandlers(
  client: AnamClient,
  events: AvatarSessionEvents
): () => void {
  const cancellers: (() => void)[] = []

  const cancelShowSources = client.registerToolCallHandler('show_sources', {
    onStart: async () => {
      // Emit a message that the UI can listen to for showing sources
      events.onMessage?.('__tool:show_sources')
      return 'Sources panel opened'
    },
  })
  cancellers.push(cancelShowSources)

  return () => {
    for (const cancel of cancellers) {
      cancel()
    }
  }
}
